
import * as sanityRuntime$TNhAnMkXT6 from '/shared/app/build/enabled/production/ssg/www/mod/momentum/providers/cdn-image-provider.ts'
import * as ipxStaticRuntime$7W9VZ4ihNb from '/shared/app/build/enabled/production/ssg/www/node_modules/.pnpm/@nuxt+image@1.8.1_db0@0.2.1_ioredis@5.4.2_magicast@0.3.5_rollup@4.30.1/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['sanity']: { provider: sanityRuntime$TNhAnMkXT6, defaults: undefined },
  ['ipxStatic']: { provider: ipxStaticRuntime$7W9VZ4ihNb, defaults: {} }
}
        